import { render, staticRenderFns } from "./CoverImage.vue?vue&type=template&id=dcdf451a&scoped=true&"
import script from "./CoverImage.vue?vue&type=script&lang=js&"
export * from "./CoverImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf451a",
  null
  
)

export default component.exports